import DownloadButton from "../DownloadButton";
import "../../styles/components/transactionPrintLayouts/ECInvoiceLayout.css";

const fallbackColumnLabels = [
  "Sl No",
  "Assy",
  "Sub Assy",
  "Part No",
  "Part Name",
  "Quantity No",
  "RM Type",
  "Total Weight (kg)",
  "RM cost",
  "Total Laser/Punching Cost",
  "Total Bending Cost",
  "Total Welding Cost",
  "Total Fastners Cost",
  "surface finish",
  "Total Coating Cost",
  "Total Process Cost",
  "Profit Cost",
  "Packing Cost",
  "Overhead &Handling Cost",
  "Part Cost Per No",
  "Total Part Cost",
];

const getFallbackValue = (item = {}, label, index) => {
  switch (label) {
    case "Sl No":
      return index + 1;
    case "Assy":
      return item.assy || "";
    case "Sub Assy":
      return item.sub_assy || "";
    case "Part No":
      return item.part_no ?? item.set_part_no ?? "";
    case "Part Name":
      return item.part_name ?? "";
    case "Quantity No":
      return item.qty_no ?? "";
    case "RM Type":
      return item.material || "";
    case "Total Weight (kg)":
      return (
        item.with_quantity_wt_in_kg ||
        item.final_weight_kg ||
        item.item_weight_kg ||
        ""
      );
    case "RM cost":
      return item.raw_mtl_cost ?? "";
    case "Total Laser/Punching Cost":
      return item.total_laser_punching_cost ?? "";
    case "Total Bending Cost":
      return item.total_bending_cost ?? item.bending_cost ?? "";
    case "Total Welding Cost":
      return item.total_welding_cost ?? item.welding_cost ?? "";
    case "Total Fastners Cost":
      return item.total_fastners_cost ?? "";
    case "surface finish":
      return item.surface_finish || "";
    case "Total Coating Cost":
      return item.total_coating_cost ?? item.powder_coating_cost ?? "";
    case "Total Process Cost":
      return item.total_process_cost ?? "";
    case "Profit Cost":
      return item.profict_cost ?? "";
    case "Packing Cost":
      return item.packing_cost ?? "";
    case "Overhead &Handling Cost":
      return item.overhead_and_handling_cost ?? "";
    case "Part Cost Per No":
      return item.part_cost_per_no ?? "";
    case "Total Part Cost":
      return item.total_part_cost ?? "";
    default:
      return "";
  }
};

export const ECInvoiceLayout = ({ itemDetails }) => {
  const rows = Array.isArray(itemDetails) ? itemDetails : [];

  const columns = fallbackColumnLabels.map((label) => ({
    label,
    fieldName: label,
  }));

  const getCellValue = (item, rowIndex, column) => {
    return getFallbackValue(item, column.label, rowIndex);
  };

  const tableData = {
    headings: columns.map((column) => ({
      display_name: column.label,
      field_name: column.fieldName,
      is_internal: false,
    })),
    rows: rows.map((item, rowIndex) => {
      const rowData = {};
      columns.forEach((column) => {
        rowData[column.fieldName] = getCellValue(item, rowIndex, column);
      });
      return rowData;
    }),
  };

  return (
    <div className="enquiry-page ec-invoice-page">
      <div className="enquiry-page-outer-container ec-invoice-outer-container">
        <div className="enquiry-page-container ec-invoice-container">
          <div className="ec-invoice-table-wrap">
            <table className="invoice-item-table ec-invoice-table">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th key={column.fieldName}>{column.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((column) => (
                      <td key={`${column.fieldName}-${rowIndex}`}>
                        {getCellValue(item, rowIndex, column)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="invoice-system-generated-note">
            This is a system-generated document and does not require a signature.
          </p>
          <div className="ec-invoice-download">
            <DownloadButton
              tableData={tableData}
              fileName={rows[0]?.tran_no || "EC-invoice"}
              downloadFormats={["excel", "pdf", "full-page-pdf"]}
              fullPageDownload={true}
              fullPageSelector=".ec-invoice-page"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
